// import Swiper from 'swiper';
// import 'swiper/css';
import Swiper from 'swiper/bundle';
import { Navigation, Pagination } from 'swiper';

import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

class JacpotSlider {
  constructor() {
    const myCustomSlider = document.querySelectorAll('.wy88-slider-jackpot');
    const myPagination = document.querySelectorAll('.swiper-pagination');

    for (let i = 0; i < myCustomSlider.length; i++) { 
      myCustomSlider[i].classList.add('wy88-slider-jackpot-' + i);
      myPagination[i].classList.add('swiper-pagination-jackpot-' + i);
      var promswiper = new Swiper('.wy88-slider-jackpot-' + i, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 3500,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination-jackpot-' + i,
        },
        loop: true
      });

    }

  }
}

export default JacpotSlider